import { env } from '@/env.mjs';

/** The caption proxy's master playlist: Mux's own, plus a machine-translated caption track per language. */
export const getCaptionMasterUrl = (governmentCode: string, playbackId: string) =>
  `${env.NEXT_PUBLIC_PUBLIC_API_URL}/governments/${encodeURIComponent(governmentCode)}/captions/${encodeURIComponent(playbackId)}/master.m3u8`;
